import { LANGS } from "../../config/langs";

function LangValidation(to, from) {
  return new Promise(function(resolve, reject) {
    if ( LANGS.indexOf(to.params.lang) > -1  || typeof to.params.lang === "undefined") {
      //=============================================
      // Временное решение - всегда русский язык
      //=============================================
      if( typeof to.params.lang === "undefined" ){
        resolve({ lang: LANGS[0] });
      }else{
        resolve({ lang: to.params.lang });
      }
      //=============================================
    } else {
      if (to.name) {
        reject({
          error: "invalid.lang",
          data: {
            name: to.name,
            params: {
              lang: LANGS[0]
            }
          }
        });
      } else {
        reject({
          error: "invalid.lang",
          data: {
            path: "/ru/"
          }
        });
      }
    }
  });
}

export default LangValidation;
